<section class="ta-page">

  <!-- ── Header ── -->
  <header class="ta-page__header">
    <div class="ta-page__header-text">
      <div class="ta-page__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M4 6h16M4 10h16M4 14h10M4 18h6"/>
        </svg>
      </div>
      <div>
        <h1 class="ta-page__title">Types d'activités</h1>
        <p class="ta-page__subtitle">Gestion des catégories d'activités</p>
      </div>
    </div>

    <app-ui-button
      label="Ajouter un type"
      variant="primary"
      size="md"
      iconLeft="add_circle_outline"
      type="button"
      [routerLink]="['add']"
    ></app-ui-button>
  </header>

  <!-- ── Card / Table ── -->
  <div class="ta-table-card">
    @if (isLoading) {
      <div class="ta-loader-wrapper">
        <app-loaderIntervantion [isLoading]="isLoading" [rows]="6"></app-loaderIntervantion>
      </div>
    } @else {
      <div class="ta-table-card__toolbar">
        <div class="ta-table-card__toolbar-left">
          <span class="ta-badge">{{ typeactitivies.length }}</span>
          <span class="ta-table-card__count">enregistrement{{ typeactitivies.length > 1 ? 's' : '' }}</span>
        </div>
      </div>

      @if (!typeactitivies.length) {
        <div class="ta-empty">
          <div class="ta-empty__icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M4 6h16M4 10h16M4 14h10M4 18h6"/>
            </svg>
          </div>
          <p class="ta-empty__title">Aucun type d'activité</p>
          <p class="ta-empty__hint">Commencez par en ajouter un en cliquant sur le bouton ci-dessus.</p>
        </div>
      } @else {
        <app-ui-table
          [columns]="tableTypeActivities"
          [data]="typeactitivies"
          [actions]="rowActions"
        ></app-ui-table>
      }
    }
  </div>

  <!-- ── Actions ligne ── -->
  <ng-template #rowActions let-item="item">
    <div class="ta-row-actions">
      <app-ui-button
        iconOnly="edit"
        variant="ghost"
        size="sm"
        ariaLabel="Modifier"
        type="button"
        [routerLink]="[
          '/',
          routeAlias.parameters.home,
          routeAlias.parameters.activity.home,
          routeAlias.parameters.activity.type_activite.home,
          routeAlias.parameters.activity.type_activite.edit,
          item.id
        ]"
      ></app-ui-button>
      <app-ui-button
        iconOnly="delete"
        variant="danger"
        size="sm"
        ariaLabel="Supprimer"
        type="button"
        (clicked)="openDeleteConfirm(item)"
      ></app-ui-button>
    </div>
  </ng-template>

</section>

<!-- Confirm Dialog -->
<app-confirm-dialog
  [isVisible]="showDeleteConfirm"
  [itemLabel]="selectedItem?.libelle || ''"
  [isLoading]="deleteLoading"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()"
></app-confirm-dialog>